import axios from 'axios';

export class CommonApi {
  /**获取所有学期信息*/
  static getSemesterAll(params?: { start_time?: string; end_time?: string; week?: Array<number>; curriculum_id?: Array<number>; store_id?: Array<number>; date?: string; }) {
    return axios.get('/api/teacher/teacher', {params: params});
  }

  /**获取五天集训证书资格列表*/
  static getCertificateList(params: { semester_id: number, start_date?: string }) {
    return axios.get<{ list: Array<any>, total: number }>('/api/certificate/training', {params: params});
  }

  /**获取所有老师信息*/
  static getTeacherAll() {
  }
}
